import { ResponsiveGridModule } from '@/src/types/common/content';
import {
  EResponsiveProductToShow,
  EnumModuleType,
} from '@/src/types/common/module';
import { countsOfItems } from '../../util';
import { EPreviewSize } from '@/src/types/common/SalesChannel';
import { get } from 'lodash';

type Params = {
  pc: ResponsiveGridModule;
  tablet: ResponsiveGridModule;
  mobile: ResponsiveGridModule;
  moduleType?: EnumModuleType;
};

class GridStrategy {
  assign(obj: any, target: any) {
    Object.assign(obj, target);
  }

  copyStrategy({ pc, breakpoint }: any) {
    const moduleType = get(pc, 'moduleType');
    switch (moduleType) {
      case EnumModuleType.ResponsiveProductGrid: {
        const { productToShow } = pc;
        if (countsOfItems(productToShow) >= 4) {
          return {
            ...pc,
            productToShow:
              breakpoint === EPreviewSize.TABLET
                ? EResponsiveProductToShow.Three
                : EResponsiveProductToShow.Two,
          };
        }
      }
      case EnumModuleType.ResponsiveContentGrid: {
        const { contentPagesToShow } = pc;
        if (countsOfItems(contentPagesToShow) >= 4) {
          return {
            ...pc,
            contentPagesToShow:
              breakpoint === EPreviewSize.TABLET
                ? EResponsiveProductToShow.Three
                : EResponsiveProductToShow.TwoPortrait,
          };
        }
      }
      default:
        return pc;
    }
  }

  contentStrategy({ pc, tablet, mobile }: Params) {
    const _tablet = tablet;
    const _mobile = mobile;
    const {
      moduleWidth,
      moduleStyle,
      contentPagesToShow,
      animation,
      moduleText,
    } = pc;

    if (countsOfItems(contentPagesToShow) >= 4) {
      this.assign(_tablet, { productToShow: EResponsiveProductToShow.Three });
      this.assign(_mobile, {
        contentPagesToShow: EResponsiveProductToShow.Two,
      });
    }

    this.assign(_tablet, {
      animation,
      moduleWidth,
      moduleText,
      moduleStyle: {
        ...mobile?.moduleStyle,
        backgroundType: moduleStyle?.backgroundType,
        backgroundColor: moduleStyle?.backgroundColor,
      },
    });
    this.assign(_mobile, {
      animation,
      moduleWidth,
      moduleText,
      moduleStyle: {
        ...mobile?.moduleStyle,
        backgroundType: moduleStyle?.backgroundType,
        backgroundColor: moduleStyle?.backgroundColor,
      },
    });
    return {
      pc,
      tablet: _tablet,
      mobile: _mobile,
    };
  }

  productStrategy({ pc, tablet, mobile }: Params) {
    const _tablet = tablet;
    const _mobile = mobile;
    const { moduleWidth, moduleStyle, animation, productToShow, moduleText } =
      pc;

    if (countsOfItems(productToShow) >= 4) {
      this.assign(_tablet, { productToShow: EResponsiveProductToShow.Three });
      this.assign(_mobile, {
        productToShow: EResponsiveProductToShow.Two,
      });
    }

    this.assign(_tablet, {
      animation,
      moduleWidth,
      moduleText,
      moduleStyle: {
        ...mobile?.moduleStyle,
        backgroundType: moduleStyle?.backgroundType,
        backgroundColor: moduleStyle?.backgroundColor,
      },
    });
    this.assign(_mobile, {
      animation,
      moduleWidth,
      moduleText,
      moduleStyle: {
        ...mobile?.moduleStyle,
        backgroundType: moduleStyle?.backgroundType,
        backgroundColor: moduleStyle?.backgroundColor,
      },
    });
    return {
      pc,
      tablet: _tablet,
      mobile: _mobile,
    };
  }

  invokeStrategy({ pc, tablet, mobile, moduleType }: Params) {
    switch (moduleType) {
      case EnumModuleType.ResponsiveContentGrid:
        return this.contentStrategy({
          pc,
          tablet,
          mobile,
        });
      case EnumModuleType.ResponsiveProductGrid:
        return this.productStrategy({
          pc,
          tablet,
          mobile,
        });
      default:
        return { pc: {}, mobile: {}, tablet: {} };
    }
  }
}

export default new GridStrategy();
